module.exports = __webpack_public_path__ + "static/media/logo.aa427071.svg";